import Backbone from 'backbone';
import ko from 'knockout';
import { result } from 'underscore';
import config from '@bingads-webui-component-legacy/config/index';
import { DisclaimerPopUpView } from '@bingads-webui-campaign-legacy/crud-ad/view/adsPreview/DisclaimerPopUpView';

const {
  IsDisclaimerAdsEnabled,
} = config.get('Permissions') || {};

export default class Panel extends Backbone.View {
  initialize({
    template,
    viewModel,
    i18n,
    adType = '',
  } = {}) {
    this.template = template;
    this.viewModel = viewModel;
    this.i18n = i18n;
    this.adType = adType;
  }

  get events() {
    return {
      'click .disclaimer-popup-link': 'displayPopupClicked',
      'click .disclaimer-popup-close': 'closePopupClicked',
    };
  }

  displayPopupClicked() {
    if (IsDisclaimerAdsEnabled && !result(this.viewModel, 'IsDisclaimerPopupHintVisible')) {
      this.viewModel.IsDisclaimerPopupHintVisible(true); //eslint-disable-line
    }
  }

  closePopupClicked() {
    if (IsDisclaimerAdsEnabled && result(this.viewModel, 'IsDisclaimerPopupHintVisible')) {
      this.viewModel.IsDisclaimerPopupHintVisible(false); //eslint-disable-line
    }
  }

  render() {
    let showDisclaimer = false;

    if (IsDisclaimerAdsEnabled && result(this.viewModel, 'ShowDisclaimer')) {
      showDisclaimer = true;
    }

    this.$el.html(this.template({
      i18n: this.i18n,
      showDisclaimer,
      adType: this.adType,
    }));

    let disclaimer = new DisclaimerPopUpView({viewModel: this.viewModel});

    this.$('.disclaimer-placeholder').empty().append(disclaimer.render().$el);

    ko.applyBindings(this.viewModel, this.el);

    return this;
  }
}
